import Util from '@/helper/Utility.js';

export function PlaceOrderModel() {
    this.firstName = '';
    this.lastName = '';
    this.contactNumber = '';
    this.channel = 'pod';
    this.userRemark = '';
    this.doNotNeedPlastic = true;
    this.doNotNeedSauce = false;
    this.useTax = false;
    this.taxName = '';
    this.taxId = '';
    this.taxBranchId = '';
    this.taxAddressKey = null;
    this.coupon = null;
    this.subtotal = 0;
    this.discount = 0;
    this.total = 0;
    // for subscription
    this.type = '';
    this.campaignId = null;

    //new params
    this.useSavedCard = false;
    this.savingCard = false;
    this.cardId = null;
    this.deliveryMethod = '';

    this.updatePlaceOrder = function (objPlaceOrderModel) {
        this.firstName = objPlaceOrderModel.firstName;
        this.lastName = objPlaceOrderModel.firstName;
        this.contactNumber = objPlaceOrderModel.contactNumber;
        this.channel = objPlaceOrderModel.channel;
        this.userRemark = objPlaceOrderModel.userRemark;
        this.doNotNeedPlastic = objPlaceOrderModel.doNotNeedPlastic;
        this.doNotNeedSauce = objPlaceOrderModel.doNotNeedSauce;
        this.useTax = objPlaceOrderModel.useTax;
        this.taxName = objPlaceOrderModel.taxName;
        this.taxId = objPlaceOrderModel.taxId;
        this.taxBranchId = objPlaceOrderModel.taxBranchId;
        this.taxAddressKey = objPlaceOrderModel.taxAddressKey;
        this.coupon = objPlaceOrderModel.coupon;
        this.subtotal = objPlaceOrderModel.subtotal;
        this.discount = objPlaceOrderModel.discount;
        this.total = objPlaceOrderModel.total;
    };

    this.setFromPaymentModel = function (objCreditCardModel) {
        this.useSavedCard = objCreditCardModel.useSavedCard;
        this.savingCard = objCreditCardModel.savingCard;
        this.cardId = objCreditCardModel.cardId;
    }

    this.updateDeliveryMethod = function (objDeliveryMethod) {
        this.deliveryMethod = objDeliveryMethod;
    }

    /**
     * Get parameter for api.
     */
    this.getParams = () => {
        let promoCode = null
        if (this.coupon) {
            promoCode = this.coupon.code;
        }
        var params = {
            firstName: this.firstName,
            lastName: this.lastName,
            contact_number: this.contactNumber,
            channel: this.channel,
            user_remark: this.userRemark,
            doNotNeedPlastic: this.doNotNeedPlastic,
            doNotNeedSauce: this.doNotNeedSauce,
            usetax: this.useTax,
            tax_addresskey: this.taxAddressKey,
            promocode: promoCode,

            //new params
            useSavedCard: this.useSavedCard,
            savingCard: this.savingCard,
            cardId: this.cardId,
            deliveryMethod: this.deliveryMethod,
        }
        return params;
    };

    this.getParamsForSubscription = () => {
        let params = {
            type: this.type,
            channel: this.channel,
            firstName: this.firstName,
            lastName: this.lastName,
            contact_number: this.contactNumber,
            useSavedCard: this.useSavedCard,
            savingCard: this.savingCard,
            cardId: this.cardId,
            campaignId: this.campaignId,
            usetax: this.useTax,
            tax_addresskey: this.useTax ? this.taxAddressKey : '',
        }
        return Util.cleanObjectEmptyStr(params);
    }
}
